export enum Features {
  InviteServiceProviders = 'invite-service-providers',
  LicenseView = 'license-view',
  NotificationPauseTesting = 'notification-pause-testing',
  PartnerIntelligence = 'partner-intelligence',
  PocketIntegration = 'pocket-integration',
  RestrictProducts = 'restrict-products',
  SkipServiceProviderValidation = 'skip-reseller-validation',
  Support = 'manage-multiverse',
}
